/*
  Previously a distinction was made between the single portal and request-create pages when rendering connect fragments.
  In Portal X, the portal home and request create page display the same connect fragments.
*/
export { HeaderConnectFragments } from './header-connect-fragments';
export { FooterConnectFragments } from './footer-connect-fragments';
